import { render, staticRenderFns } from "./ExtendedStyleArea.vue?vue&type=template&id=e5f6b15a&scoped=true&"
import script from "./ExtendedStyleArea.vue?vue&type=script&lang=js&"
export * from "./ExtendedStyleArea.vue?vue&type=script&lang=js&"
import style0 from "./ExtendedStyleArea.vue?vue&type=style&index=0&id=e5f6b15a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f6b15a",
  null
  
)

export default component.exports